const getPlaceZoomLevel = (place: Partial<Place>) => {
  const placeType = place.placeType;

  if (placeType === 'city') {
    return place.population && place.population < 300000 ? 10 : 9;
  }

  switch (placeType) {
    case 'nationalPark':
    case 'natureReserve':
      return 9;

    case 'island':
      return 10;

    case 'town':
      return 11;

    case 'village':
    case 'poi':
    case 'peak':
      return 12;

    default:
      return 16;
  }
};

export default getPlaceZoomLevel;
